import { lazy, Suspense, useEffect, useState } from "react";

const ChatWidget = lazy(() =>
  import("./ChatWidget").then((m) => ({ default: m.ChatWidget })),
);

export function DeferredChatWidget() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const schedule = () => {
      const w = window as Window & {
        requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
      };
      if (typeof w.requestIdleCallback === "function") {
        w.requestIdleCallback(() => setReady(true), { timeout: 3000 });
      } else {
        setTimeout(() => setReady(true), 1500);
      }
    };

    // Mount immediately if something asks to open the chat
    const openNow = () => setReady(true);
    window.addEventListener("agente:open", openNow);

    if (document.readyState === "complete") {
      schedule();
    } else {
      window.addEventListener("load", schedule, { once: true });
      return () => {
        window.removeEventListener("load", schedule);
        window.removeEventListener("agente:open", openNow);
      };
    }
    return () => window.removeEventListener("agente:open", openNow);
  }, []);

  if (!ready) return null;
  return (
    <Suspense fallback={null}>
      <ChatWidget />
    </Suspense>
  );
}
